import { useState } from "react";
import usePersistantState from "./usePersistantState";

export default function useFormFields(init,id=`formField${0}`) {
    const [fields, setFields] = usePersistantState(id,init);
    const handleChange = (e) => {
        const { target } = e;
        console.log(target);
        
        setFields({
            ...fields,
            [target.name]: target.value,
        });
    };
    return { fields, handleChange };
}
